// root '../../../';

// dependencies
import { Child } from 'pym.js';
import Zion from './utils/Zion';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)


// styles
import './styles/graphic.scss';

/* develblock:start */
import meta from './data/meta.json';

const d3 = require('d3');

const mapboxgl = require('mapbox-gl');
const MapboxGeocoder = require('@mapbox/mapbox-gl-geocoder');

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}


// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

mapboxgl.accessToken = 'pk.eyJ1IjoiY25uZGlnaXRhbCIsImEiOiJja2V1M3Vyd3kwMDZrMnF0Njdhb3ZhZDk5In0.OURIYzTcS6ZzoWjXJzfANg';

let isMobile = window.innerWidth < 500;
const isMd = window.innerWidth < 910 && window.innerWidth >= 736;

const mobileLocation = ['-94.5', '39'];
const desktopLocation = ['-96', '38.9'];
const startLocation = isMobile ? mobileLocation : desktopLocation;

const mobileZoom = 2;
const desktopZoom = 3.4;
const startZoom = isMobile ? mobileZoom : desktopZoom;

const optionsSm = {
  initZoom: 1.9,
  minZoom: 1,
  maxZoom: 7,
  center: [-97, 39],
  // maxBounds: [[-126, 20], [-65, 55]],
};
const optionsMd = {
  initZoom: 3.1,
  minZoom: 2.9,
  maxZoom: 6,
  center: [-97, 38.5],
  maxBounds: [[-126, 20], [-65, 55]],
};

const optionsLg = {
  initZoom: 3.4,
  minZoom: 3.4,
  maxZoom: 6,
  center: [-97, 38.5],
  maxBounds: [[-126, 20], [-65, 55]],
};

const options = isMobile ? optionsSm : isMd ? optionsMd : optionsLg;
const bounds = [[-125.04569836016663, 25.576614526747548], [-66.74896683139211, 47.71444628128205]];

const forecastMap = new mapboxgl.Map({
  container: 'snow-forecast-map',
  // style: 'mapbox://styles/cnndigital/cl960ytee001215qu1uhorjlx',
  style: 'mapbox://styles/cnndigital/cmbfliit7009r01s1hvcoe2pb',
  center: [startLocation[0], startLocation[1]],
  zoom: startZoom,
  minZoom: 2,
  maxZoom: 6,
  bearing: 0,
  scrollZoom: false,
  dragRotate: false,
  touchPitch: false,
  interactive: true,
  projection: 'albers',
});

// forecastMap.fitBounds(bounds);

forecastMap.dragRotate.disable();
forecastMap.touchZoomRotate.disableRotation();

if (!isMobile) {
  const nav = new mapboxgl.NavigationControl({
    showCompass: false,
  });
  forecastMap.addControl(nav, 'bottom-right');
}

// Update map zoom and center on resize
window.addEventListener('resize', () => {
  const wasMobile = isMobile;
  isMobile = window.innerWidth < 500;

  // If crossed the threshold, adjust zoom and center
  if (wasMobile !== isMobile) {
    const newZoom = isMobile ? mobileZoom : desktopZoom;
    const newCenter = isMobile ? mobileLocation : desktopLocation;
    forecastMap.setZoom(newZoom);
    forecastMap.setCenter(newCenter);
  }

  pymChild.sendHeight();
});

forecastMap.on('load', () => {
  const firstLayer = forecastMap.getStyle().layers[7];

  // Add state boundaries source
  forecastMap.addSource('us-states', {
    type: 'geojson',
    data: 'https://ix.cnn.io/data/gis/usa_states_conus.geojson',
  });

  // const bounds = [-125.04569836016663, 25.576614526747548, -66.74896683139211, 47.71444628128205];

  // console.log('fitting');
  // forecastMap.fitBounds(bounds);

  forecastMap.addSource('snow1', {
    type: 'raster',
    url: 'mapbox://cnndigital.wxicefore1',
  });
  forecastMap.addSource('snow2', {
    type: 'raster',
    url: 'mapbox://cnndigital.wxicefore2',
  });

  forecastMap.addSource('snow3', {
    type: 'raster',
    url: 'mapbox://cnndigital.wxicefore3',
  });


  forecastMap.addLayer({
    id: 'snow1',
    type: 'raster',
    source: 'snow1',
    layout: { visibility: 'none' },
    paint: {
      'raster-fade-duration': 0,
      'raster-opacity': 1,
    },
  },
  firstLayer.id);

  forecastMap.addLayer({
    id: 'snow2',
    type: 'raster',
    source: 'snow2',
    layout: { visibility: 'none' },
    paint: {
      'raster-fade-duration': 0,
      'raster-opacity': 1,
    },
  },
  firstLayer.id);

  forecastMap.addLayer({
    id: 'snow3',
    type: 'raster',
    source: 'snow3',
    layout: { visibility: 'visible' },
    paint: {
      'raster-fade-duration': 0,
      'raster-opacity': 1,
    },
  },
  firstLayer.id);

  // Add state borders layer (on top of snow, below labels)
  forecastMap.addLayer({
    id: 'state-borders',
    type: 'line',
    source: 'us-states',
    paint: {
      'line-color': '#999',
      'line-width': 0.5,
    },
  }, firstLayer.id);
  pymChild.sendHeight();
});
// const forecastButtons = document.querySelectorAll('.forecast.button');

// const updateForecast = (event) => {
//   const t = event.target.dataset.layer;
//   for (const layer of ['snow1', 'snow2', 'snow3']) {
//     forecastMap.setLayoutProperty(layer, 'visibility', 'none');
//   }
//   for (const b of forecastButtons) {
//     b.classList.remove('active');
//   }
//   forecastMap.setLayoutProperty(t, 'visibility', 'visible');
//   event.target.classList.add('active');
// };

// for (const button of forecastButtons) {
//   button.addEventListener('click', updateForecast);
// }


d3.timeFormatDefaultLocale({
  periods: ['a.m.', 'p.m.'],
  days: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  shortDays: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  shortMonths: [
    'Jan.',
    'Feb.',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug.',
    'Sept.',
    'Oct.',
    'Nov.',
    'Dec.',
  ],
});

d3.json('https://ix.cnn.io/data/wx-snow-forecast/forecast-date.json').then((data) => {
  const updateTime = d3.timeParse('%Y-%m-%dT%H:%M:%S%Z')(`${data.timestamp}Z`);
  const forecastEndDate = d3.timeDay.offset(updateTime, 3);

  d3.select('#forecast-map-timestamp')
    .text(`Note: Forecast through ${d3.timeFormat('%b %-d, %Y')(forecastEndDate)}, updated ${d3.timeFormat('%I:%M %p on %b %-d, %Y')(updateTime)}. Only data for the contiguous United States shown.`);
});
